import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { getDisplayName } from '@grandvisionhq/utils';
import { useBreakpointVisibility } from '../hooks/use-breakpoint-visibility.js';

function withBreakpointVisibility(Component) {
    const displayName = getDisplayName(Component);
    const WithBreakpointVisibility = (props)=>{
        return useBreakpointVisibility(props) ? /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props)) : null;
    };
    WithBreakpointVisibility.displayName = `WithBreakpointVisibility(${displayName})`;
    return WithBreakpointVisibility;
}

export { withBreakpointVisibility };
//# sourceMappingURL=with-breakpoint-visibility.js.map
